import React from "react";
import logoschool from "../../assets/images/logosignup.png";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import logotft from "../../assets/images/logotft.png";

const LandingPage = () => {
  const { signupData, setSignupData, signupDataSession, setSignupDataSession } = React.useContext(SchoolSignupContext);

  const navigate = useNavigate()
  const handleSchoolType = (type) => () => {
    navigate('/school', { state: { fromLanding: true } });
    setSignupData({
      ...signupData,
      schoolType: type,
    });
    setSignupDataSession({
      ...signupDataSession,
      schoolType: type,
    });
  }

  return (
    <>
      <div className="tft-front-page">
        <h2 className="mb-4">Choose Your Organization</h2>
        <div className="organisaton-container">
          <div className="choose-organisaton">
            <div className="choose-organisaton-img">
              <img src={logoschool} alt="Logo Here" />
            </div>
            <div className="organisation-text-info">
              <p>Empowering students through faith-based education, fostering academic excellence, and building a strong Christian community.</p>
            </div>
            <button className="btn border" onClick={handleSchoolType(2)}>Enter <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
          </div>
          <div className="choose-organisaton">
            <div className="choose-organisaton-img">
              <img src={logotft} alt="Logo Here" />
            </div>
            <div className="organisation-text-info">
              <p>The Deep Hope of Teaching for Transformation is to invite, nurture, and empower learners to live restoratively within God's story of redemption through deeper learning.</p>

            </div>
            <button className="btn border" onClick={handleSchoolType(1)} >Enter <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>

    </>);

}
export default LandingPage;

